'use client';

import { createToggleStore } from '@/lib/utils/createToggleStore';

export const useMenu = createToggleStore();
export const useExpertiseMenu = createToggleStore();
export const useSearchMenu = createToggleStore();
